import { useState, useEffect } from 'react'
import { dataLayer, type PersonalRecords } from '../../data/dataLayer'
import { playSoundIntent } from '../../utils/sound/soundIntent'
import { hapticManager } from '../../utils/hapticManager'

export function useLabData() {
  const [lastSession, setLastSession] = useState<{
    modeId: string
    familyId?: string
    timestamp: number
    score?: number
  } | null>(null)
  const [newlyUnlockedFamilyId, setNewlyUnlockedFamilyId] = useState<
    string | null
  >(null)
  const [showCelebration, setShowCelebration] = useState(false)
  const [personalRecords, setPersonalRecords] = useState<PersonalRecords>({})

  useEffect(() => {
    dataLayer
      .getLastOefenlabSession()
      .then((session) => {
        if (session) {
          setLastSession(session)
        }
      })
      .catch(() => {})

    dataLayer
      .getNewlyUnlockedChallenge()
      .then((familyId) => {
        if (familyId) {
          setNewlyUnlockedFamilyId(familyId)
          setShowCelebration(true)
          playSoundIntent('reward.achievement')
          hapticManager.hapticHeavy()
          dataLayer.clearNewlyUnlockedChallenge()
        }
      })
      .catch(() => {})

    dataLayer
      .getPersonalRecords()
      .then((records) => {
        setPersonalRecords(records)
      })
      .catch(() => {})
  }, [])

  return {
    lastSession,
    newlyUnlockedFamilyId,
    setNewlyUnlockedFamilyId,
    showCelebration,
    personalRecords,
  }
}
